import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { captureMessage } from '@sentry/nextjs'
import { useState } from 'react'

import Button from 'components/Button'
import content from 'prismic-translates/common.json'

import classes from './styles.module.scss'

type TSharingNativeMobile = {
  title?: string
  text?: string
  url?: string
  className?: string
  dataTestId?: string
}

export const SharingNativeMobile = ({ url, title, text, dataTestId }: TSharingNativeMobile) => {
  const [sharingIsActive, setSharingIsActive] = useState(false)
  const t = getTranslationFromJson([content])

  const handleClick = async (): Promise<void> => {
    if (!navigator?.share) {
      return
    }

    setSharingIsActive(true)
    const shareData = {
      ...(title && { title }),
      ...(text && { text }),
      ...(url && { url }),
    }

    try {
      await navigator.share(shareData)
    } catch (err) {
      if (!err.toString().includes('AbortError')) {
        const message = `Error in SharingNativeMobile: ${err?.message}; Agent: ${navigator?.userAgent}`
        console.error(message)
        captureMessage(message)
      }
    } finally {
      setSharingIsActive(false)
    }
  }

  return (
    <Button
      disabled={sharingIsActive}
      onClick={handleClick}
      variant='contained'
      size='small'
      className={classes.button}
      dataTestId={dataTestId}
    >
      {t('share')}
    </Button>
  )
}
